import { Box, Button, Grid, Typography } from '@mui/material';
import { DataGrid, esES } from '@mui/x-data-grid';
import { DataGridStyle } from '../../../../../styles/DataGridSytle';
import { useLocation } from 'react-router-dom';
import { numericFormatter } from 'react-number-format';
import { useEffect, useState } from 'react';
import { sendRequest } from '../../../../../services/request';
import * as XLSX from 'xlsx';
import ListHeader from './listheader';
import { formatterCOP, formatterPTY } from '../../../../../utils/utils';
import dayjs from 'dayjs';

export const BDDConsolidada = ({ pais }) => {
    const [rows, setRows] = useState([]);
    const [limit, setLimit] = useState(50);
    const [page, setPage] = useState(0);
    const [rowCount, setRowCount] = useState(null);

    //Loading
    const [loading, setLoading] = useState(false);

    const [isSemana, setIsSemana] = useState(false);

    // Week Picker
    const [fecha, setFecha] = useState(null);
    // const [hoveredDay, setHoveredDay] = useState(null);

    // Resumen
    const [resumen, setResumen] = useState({
        donacion: null,
        cantidad: null,
    });

    //Eqipos
    const [equipos, setEquipos] = useState([]);
    const [equipo, setEquipo] = useState('');

    const location = useLocation();
    const URL = process.env.REACT_APP_API_URL;

    const campana = location.state?.campana;

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const res = await sendRequest(
                    'get',
                    `${URL}/${pais}/envio?page=${page}&limit=${limit}&campanaId=${
                        campana.id
                    }&estado=9&fecha_cierre=${
                        fecha ? dayjs(fecha).format('YYYY-MM-DD') : ''
                    }&equipoId=${equipo?.id || ''}&semana=${isSemana}`,
                );
                setRows(res.data.items);
                setRowCount(res.data.meta.totalItems);
                setLoading(false);
                setResumen({
                    donacion:
                        pais === 'colombia'
                            ? formatterCOP.format(res.data.total_donaciones)
                            : formatterPTY.format(res.data.total_donaciones),
                    cantidad: res.data.meta.totalItems,
                });
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [URL, pais, page, limit, campana.id, fecha, equipo, isSemana]);

    useEffect(() => {
        const fetchEquipos = async () => {
            try {
                const res = await sendRequest(
                    'get',
                    `${URL}/${pais}/equipos?campanas=${campana.id}`,
                );
                setEquipos(res.data.items);
            } catch (error) {
                console.log(error);
            }
        };
        fetchEquipos();
    }, [URL, pais, equipo, campana.id]);

    const columns = [
        {
            field: 'cliente',
            headerName: campana.division.id === 1 ? 'Cliente' : 'Donante',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            flex: 1,
            minWidth: 150,
            valueFormatter: ({ value }) =>
                `${value.nombres} ${value.apellidos ? value.apellidos : ''}`,
            renderCell: ({ row }) =>
                `${row.cliente?.nombres} ${
                    row.cliente.apellidos ? row.cliente.apellidos : ''
                }`,
        },
        {
            field: 'celular',
            headerName: 'Celular',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            flex: 1,
            minWidth: 150,
            renderCell: ({ row }) => row.cliente?.celular,
        },
        {
            field: 'correo',
            headerName: 'Correo',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            flex: 1,
            minWidth: 150,
            renderCell: ({ row }) => row.cliente?.correo,
        },
        {
            field: 'promotor',
            headerName: 'Promotor',
            flex: 'auto',
            headerClassName: 'header',
            editable: true,
            sortable: false,
            headerAlign: 'center',
            align: 'center',
            renderCell: ({ row }) =>
                `${row.promotor?.nombres} ${row.promotor?.apellidos}`,
        },
        {
            field: 'medio_pago',
            headerName: 'Medio de Pago',
            headerClassName: 'header',
            editable: true,
            sortable: false,
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            minWidth: 150,
            renderCell: ({ row }) => (
                <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {row?.medio_pago?.nombre}
                </Box>
            ),
        },
    ];

    if (campana.con_delivery) {
        const destinoColumn = [
            {
                field: 'destino',
                headerName: 'Destino',
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                flex: 1,
                minWidth: 150,
                valueGetter: ({ row }) => row.cliente?.direccion_exacta,
                renderCell: ({ row }) => (
                    <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        {row.cliente?.direccion_exacta}
                    </Box>
                ),
            },
        ];
        columns.splice(2, 0, ...destinoColumn);
    }

    if (campana.division.id === 1) {
        const pubColumns = [
            {
                field: 'cantidad',
                headerName: 'Cantidad',
                headerClassName: 'header',
                editable: true,
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                flex: 1,
                minWidth: 150,
                renderCell: ({ row }) => row.cantidad,
            },
        ];
        columns.splice(!campana.con_delivery ? 3 : 4, 0, ...pubColumns);
    } else if (campana.division.id === 2) {
        const fundColumns = [
            {
                field: 'donacion_total',
                headerName: 'Donación Total',
                headerClassName: 'header',
                sortable: false,
                headerAlign: 'center',
                align: 'center',
                flex: 1,
                minWidth: 150,
                renderCell: ({ row }) => {
                    return numericFormatter(row.donacion_total.toString(), {
                        thousandSeparator: true,
                        prefix: pais === 'colombia' ? '$' : 'B/. ',
                        decimalScale: 2,
                        fixedDecimalScale: true,
                    });
                },
            },
        ];
        columns.splice(!campana.con_delivery ? 3 : 4, 0, ...fundColumns);
    }

    const handlePaginationChange = (event) => {
        setPage(event.page);
        setLimit(event.pageSize);
    };

    const handleExportar = () => {
        // Extract data from rows and columns
        const data = rows.map((row) => {
            const dataValue = {
                cliente: `${row.cliente?.nombres || ''} ${
                    row.cliente?.apellidos || ''
                }`,
                celular: row.cliente.celular,
                correo: row.cliente.correo,
                destino: row.cliente?.direccion_exacta,
                cantidad: row.cantidad,
                medio_pago: row.medio_pago?.nombre,
                donacion_total: row.donacion_total,
            };
            if (!campana.con_delivery) {
                delete dataValue.destino;
            }
            if (campana.division.id === 1) {
                delete dataValue.donacion_total;
            }
            if (campana.division.id === 2) {
                delete dataValue.cantidad;
            }
            return { ...dataValue };
        });

        // Create a worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Export the workbook to an Excel file
        XLSX.writeFile(workbook, `BDDConsolidada_${campana.nombre}.xlsx`);
    };

    return (
        <Grid container>
            <Grid container spacing={5} py={3} pr={3}>
                <Grid item xs={10}>
                    <Typography
                        variant="h4"
                        color="primary"
                        sx={{
                            textAlign: 'start',
                            marginLeft: '10px',
                        }}
                    >
                        Validación BDD y Delivery / BDD Consolidada /{' '}
                        {campana.nombre}
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleExportar}
                    >
                        Exportar a excel
                    </Button>
                </Grid>
            </Grid>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    width: '100%',
                }}
            >
                <Box
                    sx={{
                        minWidth: '80%',
                        maxWidth: '80%',
                    }}
                >
                    {/* Primer bloque: Filtros y Cuadro */}
                    <Grid container spacing={2}>
                        {/* Filtros */}
                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={8}>
                                    <ListHeader
                                        fecha={fecha}
                                        setFecha={setFecha}
                                        // hoveredDay={hoveredDay}
                                        // setHoveredDay={setHoveredDay}
                                        equipos={equipos}
                                        setEquipo={setEquipo}
                                        isSemana={isSemana}
                                        setIsSemana={setIsSemana}
                                    />
                                </Grid>

                                {/* Cuadro de Donacion Total */}
                                <Grid item xs={12} md={4}>
                                    <Box
                                        sx={{
                                            pt: 1,
                                            height: '100%', // para que tenga mismo alto que filtros
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'start',
                                        }}
                                    >
                                        <Typography
                                            color="primary"
                                            variant="h5"
                                        >
                                            Resumen
                                        </Typography>

                                        <Grid container spacing={1}>
                                            <Grid item>
                                                <Typography
                                                    variant="subtitle1"
                                                    fontWeight="bold"
                                                >
                                                    Total Donantes:
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="subtitle1">
                                                    {resumen.cantidad}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1}>
                                            <Grid item>
                                                <Typography
                                                    variant="subtitle1"
                                                    fontWeight="bold"
                                                >
                                                    Recaudación Total:
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="subtitle1">
                                                    {resumen.donacion}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Segundo bloque: DataGrid ocupa todo */}
                        <Grid item xs={12}>
                            <DataGrid
                                localeText={
                                    esES.components.MuiDataGrid.defaultProps
                                        .localeText
                                }
                                disableColumnSelector
                                disableDensitySelector
                                disableColumnFilter
                                disableColumnMenu
                                disableRowSelectionOnClick
                                loading={loading}
                                initialState={{
                                    pagination: {
                                        paginationModel: { pageSize: limit },
                                    },
                                }}
                                rows={rows}
                                columns={columns}
                                paginationMode="server"
                                onPaginationModelChange={handlePaginationChange}
                                rowCount={rowCount || 0}
                                sx={[
                                    DataGridStyle,
                                    {
                                        '& .MuiDataGrid-virtualScroller': {
                                            minHeight: '30vh',
                                        },
                                    },
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Grid>
    );
};
